// extracted by mini-css-extract-plugin
module.exports = {"tooltip-base":"nwea-ds-v1-button-tooltip-base"};